import request from '@/utils/request'
export default {
  // 上传图片
  upload(data) {
    return request({
      url: '/common/upload',
      method: 'POST',
      data
    })
  }
}